var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{underline: _vm.underline},attrs:{"rel":_vm.rel,"target":_vm.target,"href":_vm.href},on:{"click":function($event){return _vm.onClick($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }